import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

export function getPhoneDigitsOnly(number) {
  if (typeof number === 'number') number = '' + number;
  if (typeof number !== 'string') return null;
  const numberOnly = number.replace(/[\D]/g, '');
  const numberLength = numberOnly.length;
  return numberLength > 10
    ? numberOnly.substring(numberLength - 10)
    : numberOnly;
}

export function phoneIsValidFormat(number) {
  return /^([+]?1)?((\(\d{3}\)[ ]?(\d{3}-\d{4}|\d{7}))|(\d{3}(-\d{3}-\d{4}|-?\d{7})))$/.test(
    number
  );
}

export function formatPhone(number) {
  try {
    const DEFAULT_REGION = 'US';
    if (typeof number === 'number') number = '' + number;
    if (number) {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const phoneParsed = phoneUtil.parseAndKeepRawInput(
        number,
        DEFAULT_REGION
      );
      return phoneUtil.format(phoneParsed, PhoneNumberFormat.NATIONAL);
    }
    return '';
  } catch {
    // If the phone number is invalid just return the original number
    console.log('Invalid phone passed: ' + number);
    return number;
  }
}
